export enum RoverBrand {
  Rover = 'rover',
  CatInAFlat = 'cat-in-a-flat',
}

export enum RoverBrandAriaLabel {
  Rover = 'Rover',
  CatInAFlat = 'Cat in a Flat',
}

export type RoverBrandContextType = {
  brand: RoverBrand;
  isCatInAFlat: boolean;
  isRover: boolean;
};

export type RoverBrandProviderProps = {
  brand?: RoverBrand;
  children: React.ReactNode;
};
